// LiveStreamPusherHandler.js
import { connect } from 'react-redux';

import { JWT_SCOPE_LIVESTREAM_MODERATOR } from '../RemoteConfigKeys.js';

import LiveStreamPusherHandler from '../component/LiveStreamPusherHandler.jsx';
import subscribeStreamChannel from '../action/subscribeStreamChannel.js';
import unsubscribeStreamChannel from '../action/unsubscribeStreamChannel.js';
import subscribeStreamViewerChannel from '../action/subscribeStreamViewerChannel.js';
import unsubscribeStreamViewerChannel from '../action/unsubscribeStreamViewerChannel.js';
import subscribePresenceGoalChannel from '../action/subscribePresenceGoalChannel.js';
import unsubscribePresenceGoalChannel from '../action/unsubscribePresenceGoalChannel.js';
import {
  subscribePresenceStreamExclusive,
  unsubscribePresenceStreamExclusive,
} from '../action/presenceStreamExclusiveChannelHandler.js';

import getLiveStreamData from '../selector/getLiveStreamData.js';
import getMeData from '../selector/getMeData.js';
import getGoalData from '../selector/getGoalData.js';
import getIsPermissionMatched from '../selector/getIsPermissionMatched.js';

const mapStateToProps = (state, { streamId }) => {
  const pusherPreset = getLiveStreamData(state, [streamId], 'pusherPreset');
  const meId = getMeData(state, 'id');
  const fundingId = getLiveStreamData(
    state,
    [streamId, 'privateShow'],
    'fundingId'
  );
  const exclusivePrivateStatus = getLiveStreamData(
    state,
    [streamId, 'exclusivePrivate'],
    'status'
  );
  const currentExclusivePrivateId = getLiveStreamData(
    state,
    [streamId, 'exclusivePrivate'],
    'currentId'
  );
  const exclusivePrivateBuyerId = getGoalData(
    state,
    [currentExclusivePrivateId, 'context'],
    'exclusive_to'
  );

  const isLivestreamModerator = getIsPermissionMatched(
    state,
    JWT_SCOPE_LIVESTREAM_MODERATOR
  );
  return {
    pusherPreset,
    meId,
    fundingId,
    exclusivePrivateStatus,
    exclusivePrivateBuyerId,
    isLivestreamModerator,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    subscribeStreamChannel: data => dispatch(subscribeStreamChannel(data)),
    unsubscribeStreamChannel: data => dispatch(unsubscribeStreamChannel(data)),
    subscribeStreamViewerChannel: data =>
      dispatch(subscribeStreamViewerChannel(data)),
    unsubscribeStreamViewerChannel: data =>
      dispatch(unsubscribeStreamViewerChannel(data)),
    subscribePresenceGoalChannel: data =>
      dispatch(subscribePresenceGoalChannel(data)),
    unsubscribePresenceGoalChannel: data =>
      dispatch(unsubscribePresenceGoalChannel(data)),
    subscribePresenceStreamExclusive: data =>
      dispatch(subscribePresenceStreamExclusive(data)),
    unsubscribePresenceStreamExclusive: data =>
      dispatch(unsubscribePresenceStreamExclusive(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiveStreamPusherHandler);
